// extracted by mini-css-extract-plugin
module.exports = {"component":"video_component__TBGY_"};